
export const periods = [
    '2026-02-23',
    '2026-03-02',
    '2026-03-09',
];

export const dishes = [
    '4875',
    '4331',
    '3889',
    '5312',
];
